import { useCallback } from 'react'

import { useConversation } from '../../../../providers/ConversationProvider'
import {
  type ConversationChoiceOption,
  type ConversationTurnItem,
} from '../../../../value-objects/ConversationTurnItem'
import { ConversationStreamStatuses } from '../../models/useConversationStream'

interface IUseRunConversationTurnPresenterResult {
  data: {
    items: ConversationTurnItem[]
  }
  states: {
    isStreaming: boolean
  }
  commands: {
    selectChoice: (option: ConversationChoiceOption) => void
  }
}

export const useRunConversationTurnPresenter =
  (): IUseRunConversationTurnPresenterResult => {
    const { items, status, sendMessage } = useConversation()

    const selectChoice = useCallback(
      (option: ConversationChoiceOption) => sendMessage(option.message),
      [sendMessage]
    )

    return {
      data: { items },
      states: {
        isStreaming: status === ConversationStreamStatuses.STREAMING,
      },
      commands: { selectChoice },
    }
  }
